function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UKFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_3872",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18,
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_3872)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_3872",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_3872)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "mask2_621_3872",
        style: {
          maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "3",
        width: "24",
        height: "18",
        children: /*#__PURE__*/_jsx("rect", {
          y: "3",
          width: "24",
          height: "18",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_3872)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M-2.67236 19.714L2.6089 21.9476L24.1198 5.42837L26.9056 2.10926L21.258 1.36274L12.4842 8.48135L5.42223 13.2776L-2.67236 19.714Z",
          fill: "white"
        }), /*#__PURE__*/_jsx("path", {
          d: "M-1.94934 21.2789L0.741221 22.5751L25.9052 1.80088H22.1274L-1.94934 21.2789Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M26.6724 19.714L21.3911 21.9476L-0.119832 5.42837L-2.90558 2.10926L2.74197 1.36274L11.5158 8.48135L18.5778 13.2776L26.6724 19.714Z",
          fill: "white"
        }), /*#__PURE__*/_jsx("path", {
          d: "M26.4922 20.8372L23.8016 22.1333L13.0865 13.2388L9.90973 12.245L-3.1736 2.12064H0.604259L13.6802 12.0047L17.1535 13.1964L26.4922 20.8372Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("mask", {
          id: "path-9-inside-1_621_3872",
          fill: "white",
          children: /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.8333 1.5H9.16665V9H-1.47937V15H9.16665V22.5H14.8333V15H25.5206V9H14.8333V1.5Z"
          })
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.8333 1.5H9.16665V9H-1.47937V15H9.16665V22.5H14.8333V15H25.5206V9H14.8333V1.5Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M9.16665 1.5V0.5H8.16665V1.5H9.16665ZM14.8333 1.5H15.8333V0.5H14.8333V1.5ZM9.16665 9V10H10.1666V9H9.16665ZM-1.47937 9V8H-2.47937V9H-1.47937ZM-1.47937 15H-2.47937V16H-1.47937V15ZM9.16665 15H10.1666V14H9.16665V15ZM9.16665 22.5H8.16665V23.5H9.16665V22.5ZM14.8333 22.5V23.5H15.8333V22.5H14.8333ZM14.8333 15V14H13.8333V15H14.8333ZM25.5206 15V16H26.5206V15H25.5206ZM25.5206 9H26.5206V8H25.5206V9ZM14.8333 9H13.8333V10H14.8333V9ZM9.16665 2.5H14.8333V0.5H9.16665V2.5ZM10.1666 9V1.5H8.16665V9H10.1666ZM-1.47937 10H9.16665V8H-1.47937V10ZM-0.47937 15V9H-2.47937V15H-0.47937ZM9.16665 14H-1.47937V16H9.16665V14ZM10.1666 22.5V15H8.16665V22.5H10.1666ZM14.8333 21.5H9.16665V23.5H14.8333V21.5ZM13.8333 15V22.5H15.8333V15H13.8333ZM25.5206 14H14.8333V16H25.5206V14ZM24.5206 9V15H26.5206V9H24.5206ZM14.8333 10H25.5206V8H14.8333V10ZM13.8333 1.5V9H15.8333V1.5H13.8333Z",
          fill: "white",
          mask: "url(#path-9-inside-1_621_3872)"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=UK.js.map